<template>
  <div>
    <template v-if="coupon_total>0">
    <div class="coupon_list_box">
      <div class="coupon_box flex_center" v-for="(coupon_item,coupon_index) in couponList" :key="coupon_index">
      <div class="coupon_left">
        <img src="/static/img/coupon_bg.png" alt />
        <div style="position:absolute;top:13%;left:0;width:100%;">
          <p class="coupon_price">￥{{coupon_item.price}}</p>
          <p class="coupon_type">代金券</p>
        </div>
      </div>
      <div class="flex_center" style="width: 65%;">
        <div class="coupon_middle">
          <p class="coupon_condition">{{coupon_item.coupon_name}}</p>
          <p class="coupon_usetime">满{{coupon_item.enough}}使用</p>
          <p class="coupon_usetime" v-if="coupon_item.use_starttime==0">不限时间</p>
          <p class="coupon_usetime" v-else>{{coupon_item.use_starttime}} - {{coupon_item.use_endtime}}</p>
        </div>
        <div class="coupon_right">
          <a @click="use_coupon(coupon_item.id)" class="gotouse_btn">立即使用</a>
        </div>
      </div>
    </div>
    </div>
    
    <div class="no_use" @click="no_use()">
      <p>不使用优惠券</p>
    </div>
    </template>
    <template v-else>
      <div class="item_none" >暂无优惠券</div>
    </template>
  </div>
</template>

<script>
  export default {
    name: "selectCoupon",
    data(){
      return{
        service_id:0,
        store_id:0,
        tech_id:0,
        member_total:0,
        service_time:0,
        //技师列表
        couponList: [],
        coupon_total:0
      }
    },
     created(){
       this.service_id = this.$route.query.service_id;
       this.tech_id  =this.$route.query.tech_id;
       this.store_id = this.$route.query.store_id;
       this.member_total = this.$route.query.member_total;
       this.service_time = this.$route.query.service_time;
       this.get_coupon();
    },
    methods:{
      get_coupon(){
        this.axios({
            url: this.api.order.select_coupon_list,
            data:{
              'service_id':this.service_id,
              'service_time':this.service_time,
              'member_total':this.member_total,
              'tech_id':this.tech_id
            }
        }).then((res) => {
            if (res.error === 0) {
              this.couponList  = res.coupon;
              this.coupon_total = res.coupon_total

            }

        })
      },
      use_coupon(coupon_id=0){
          if(coupon_id>0){
            this.axios({
            url: this.api.order.select_coupon,
            data:{
              'service_id':this.service_id,
              'service_time':this.service_time,
              'member_total':this.member_total,
              'tech_id':this.tech_id,
              'coupon_id':coupon_id
            }
            }).then((res) => {
                if (res.error === 0) {
                   //修改缓存
                  var order  = JSON.parse(sessionStorage.getItem("order"));
                  order['select_coupon'] = res;
                  
                  sessionStorage.setItem('order',JSON.stringify(order));
                  var jump_data = {
                    'service_id':this.service_id,
                    'store_id':this.store_id,  
                    'tech_id':this.tech_id,
                    'member_total':this.member_total              
                  }
                  this.$router.push({path:'bookOrder',query:jump_data});      
                }

            })
          }else{
            return;
          }
      },
      no_use(){
        //修改缓存
        var order  = JSON.parse(sessionStorage.getItem("order"));
        order['select_coupon'] = [];
        sessionStorage.setItem('order',JSON.stringify(order));
        var jump_data = {
          'service_id':this.service_id,
          'store_id':this.store_id,  
          'tech_id':this.tech_id,
          'member_total':this.member_total              
        }
        this.$router.push({path:'bookOrder',query:jump_data});      
      }
    }
  }
</script>

<style scoped>
  .coupon_list_box{
    margin-bottom: 10rem;
  }
  .coupon_box {
    margin: .5rem;
    background-color: white;
    clear: both;
    overflow: hidden;
  }
  .coupon_left {
    position: relative;
    color: #ffffff;
    text-align: center;
    width: 35%;
    clear: both;
  }
  .coupon_left img {
    width: 100%;
    height: 3.3rem;
  }
  .coupon_price {
    font-size: 1.2rem;
    font-weight: bold;
  }
  .coupon_type {
    font-size: 0.6rem;
  }
  .coupon_middle {
    width: 62%;
    padding-left: 5%;
  }
  .coupon_right {
    width: 38%;
    font-size: 0.6rem;
    color: #45b9bc;
    padding-right: .5rem;
    text-align: right;
  }
  .coupon_condition {
    font-size: 0.6rem;
    color: #6a6969;
    padding-bottom: 0.2rem;
  }
  .coupon_usetime {
    font-size: 0.5rem;
    color: #a3a3a3;
  }
  .gotouse_btn {
    border: 1px solid #45b9bc;
    border-radius: 5px;
    padding: 0.2rem 0.3rem;
  }
  .item_none{
    text-align:center;
    font-size:.75rem;
    color:#666;
    margin-top:5rem;
  }
  .no_use{
    text-align: center;
    position: fixed;
    bottom: 0;
    margin: auto;
    width: 100%;
    padding: .8rem;
    background: #45b9bc;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/views/book/selectCoupon.vue